<template>
    <div
        id="be-elenco-agenti"
        class="bg-light"
    >
        <div class="body-wrapper">
            <backend-header />
            <main>
                <div class="barra-titolo-azioni bg-white border-bottom py-2">
                    <div class="container-fluid">
                        <div class="row d-flex justify-content-between flex-wrap align-items-center">
                            <div class="col-sm-5">
                                <h1 class="mb-0">{{ $t("Collaboratori") }}</h1>
                            </div>
                            <div class="col-sm-7 mt-3 mt-sm-0">
                                <ul class="d-sm-flex justify-content-end flex-wrap mb-0">
                                    <li class="d-inline-block">
                                        <button
                                            class="pulsante-nuovo-agente btn btn-primary btn-rikorda1"
                                            v-b-modal.new-agent-modal
                                        >
                                            {{ $t("Nuovo collaboratore") }}
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <b-table-lite
                        class="elenco-agenti tabella-responsive table mt-3 mb-0"
                        id="agents-table"
                        striped
                        hover
                        :items="agents"
                        :fields="tableFields"
                    >
                        <template #cell(azioni)="data">
                            <b-dropdown
                                toggle-class="text-decoration-none"
                                variant="light border rounded-0"
                                menu-class="w-100 text-center"
                                right
                            >
                                <b-dropdown-item @click="openEditAgentModal(data.item.fkUtenteAgente)">
                                    {{$t('Modifica')}}
                                </b-dropdown-item>
                                <b-dropdown-item @click="openDeleteAgentModal(data.item.fkUtenteAgente)">
                                    {{$t('Elimina')}}
                                </b-dropdown-item>
                            </b-dropdown>
                        </template>
                    </b-table-lite>
                </div>
            </main>
            <backend-footer />
            <!-- popup nuovo agente -->
            <ValidationObserver v-slot="{ handleSubmit }">
                <b-modal
                    id="new-agent-modal"
                    ref="newAgentModal"
                    title="Nuovo collaboratore"
                    @show="resetNewAgentModal"
                >
                    <div class="col-sm-12">
                        <label for="agent">{{ $t("Email collaboratore") }}</label>
                        <ValidationProvider
                            rules="required|email|validEmail"
                            mode="passive"
                            :debounce="5"
                            v-slot="{ errors, touched, valid, invalid, pending, validate }"
                            tag="div"
                        >
                            <input
                                type="email"
                                class="form-control"
                                :class="{'is-valid': touched && !pending && valid, 'is-invalid': touched && !pending && invalid, 'validating': pending}"
                                id="agent"
                                v-model="newAgent"
                                @chagne="validate()"
                            />
                            <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <template #modal-footer="{cancel}">
                        <b-button
                            class="btn btn-light border"
                            @click="cancel()"
                        >
                            {{ $t("Annulla") }}
                        </b-button>
                        <b-button
                            class="btn btn-primary btn-rikorda1"
                            @click.prevent="handleSubmit(insertAgent)"
                        >
                            {{ $t("Aggiungi") }}
                        </b-button>
                    </template>
                </b-modal>
            </ValidationObserver>
            <!-- popup modifica agente -->
            <ValidationObserver v-slot="{ handleSubmit }">
                <b-modal
                    id="edit-agent-modal"
                    title="Modifica collaboratore"
                    ref="editAgentModal"
                >
                    <input
                        type="hidden"
                        class="form-control"
                        id="agent-id"
                        v-model="updatingAgent.fkUtenteAgente"
                    />
                    <div class="col-sm-12">
                        <label for="name">{{ $t("Nome") }}</label>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <input
                                type="text"
                                class="form-control"
                                id="name"
                                v-model="updatingAgent.nome"
                            />
                            <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="col-sm-12">
                        <label for="lastname">{{ $t("Cognome") }}</label>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                        >
                            <input
                                type="text"
                                class="form-control"
                                id="lastname"
                                v-model="updatingAgent.cognome"
                            />
                            <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <div class="col-sm-12">
                        <label for="email">{{ $t("Email") }}</label>
                        <ValidationProvider
                            rules="required|email"
                            v-slot="{ errors }"
                        >
                            <input
                                type="email"
                                class="form-control"
                                id="email"
                                v-model="updatingAgent.email"
                            />
                            <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <template #modal-footer="{cancel}">
                        <b-button
                            class="btn btn-light border"
                            @click="cancel()"
                        >
                            {{ $t("Annulla") }}
                        </b-button>
                        <b-button
                            class="btn btn-primary btn-rikorda1"
                            @click.prevent="handleSubmit(updateAgent)"
                        >
                            {{ $t("Salva") }}
                        </b-button>
                    </template>
                </b-modal>
            </ValidationObserver>
            <!-- popup rimozione agente -->
            <b-modal
                id="remove-agent-modal"
                ref="removeAgentModal"
                title="Elimina collaboratore"
                :cancel-title="$t('Annulla')"
                :ok-title="$t('Elimina')"
                :ok-variant="'danger'"
                @ok.prevent="deleteAgent"
            >
                <div>pippo</div>
                <div>{{$t('Sei sicuro di voler rimuovere il collaboratore')}} {{removingAgent.email}}?</div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import BackendHeader from "../../components/backend/Header";
import BackendFooter from "../../components/backend/Footer";
import {
    BModal,
    BTableLite,
    BDropdown,
    BDropdownItem,
    BButton
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { validEmail } from "../../../src/main.js";

export default {
    name: "BackendAgents",
    components: {
        BackendFooter,
        BackendHeader,
        BModal,
        BTableLite,
        BDropdown,
        BDropdownItem,
        BButton,
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            agents: [],
            newAgent: "",
            updatingAgent: {
                fkUtenteAgente: "",
                nome: "",
                cognome: "",
                email: ""
            },
            removingAgent: {
                fkUtenteAgente: "",
                email: ""
            },
            tableFields: [
                { key: "nome" },
                { key: "cognome" },
                { key: "email" },
                { key: "stato" },
                { key: "dataInvito" },
                { key: "azioni" }
            ]
        };
    },
    mounted() {
        if (this.$store.getters.isAgent) {
            this.$router.push({
                name: "backend-dashboard"
            });
        } else {
            this.loadAgents();
        }
        extend("required", {
            ...required,
            message: "Questo campo è obbligatorio"
        });
        extend("email", {
            ...email,
            message: "Inserisci un indirizzo email valido"
        });
    },
    methods: {
        loadAgents() {
            this.$api
                .backendGetAgents()
                .then((result) => {
                    console.debug("BACKEND_GET_AGENTS", result);
                    this.agents = result.agents;
                    this.agents.forEach((el) => {
                        let date = moment(String(el.dataInvito));
                        if (date.isValid()) {
                            el.dataInvito = date.format("DD/MM/YYYY");
                        }
                    });
                })
                .catch((error) => {
                    console.error("BACKEND_GET_AGENTS", error);
                });
        },
        resetNewAgentModal() {
            this.newAgent = "";
        },
        insertAgent() {
            this.$api
                .backendInsertAgent(this.newAgent)
                .then((result) => {
                    console.debug("BACKEND_INSERT_AGENT", result);
                    this.$refs.newAgentModal.hide();
                    this.loadAgents();
                })
                .catch((error) => {
                    console.error("BACKEND_INSERT_AGENT", error);
                });
        },
        openEditAgentModal(fkUtenteAgente) {
            let editingAgent = this.agents.filter((el) => {
                return el.fkUtenteAgente === fkUtenteAgente;
            });
            editingAgent = editingAgent[0];
            this.updatingAgent.fkUtenteAgente = editingAgent.fkUtenteAgente;
            this.updatingAgent.nome = editingAgent.nome;
            this.updatingAgent.cognome = editingAgent.cognome;
            this.updatingAgent.email = editingAgent.email;
            this.$refs.editAgentModal.show();
        },
        updateAgent() {
            let params = {
                fkUtenteAgente: this.updatingAgent.fkUtenteAgente,
                nome: this.updatingAgent.nome,
                cognome: this.updatingAgent.cognome,
                email: this.updatingAgent.email
            };
            this.$api
                .backendUpdateAgent(params)
                .then((result) => {
                    console.debug("BACKEND_INSERT_AGENT", result);
                    this.$refs.editAgentModal.hide();
                    this.loadAgents();
                })
                .catch((error) => {
                    console.debug("BACKEND_INSERT_AGENT", error);
                });
        },
        openDeleteAgentModal(fkUtenteAgente) {
            let editingAgent = this.agents.filter((el) => {
                return el.fkUtenteAgente === fkUtenteAgente;
            });
            editingAgent = editingAgent[0];
            this.removingAgent.fkUtenteAgente = editingAgent.fkUtenteAgente;
            this.removingAgent.email = editingAgent.email;
            this.$refs.removeAgentModal.show();
        },
        deleteAgent() {
            let params = {
                fkUtenteAgente: this.removingAgent.fkUtenteAgente
            };
            this.$api
                .backendDeleteAgent(params)
                .then((result) => {
                    console.debug("BACKEND_INSERT_AGENT", result);
                    this.$refs.removeAgentModal.hide();
                    this.loadAgents();
                })
                .catch((error) => {
                    console.debug("BACKEND_INSERT_AGENT", error);
                });
        }
    }
};
</script>

<style scoped>
</style>
